var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-page pcStyle"},[_c('Header'),_c('div',{staticClass:"page-content"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/success.png"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.successTitle))]),_c('div',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.successSubTitle))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }